import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'toro-turf-pro-linear-gauge',
    templateUrl: './turf-pro-linear-gauge.component.html',
    styleUrls: ['./turf-pro-linear-gauge.component.less']
})
export class TurfProLinearGaugeComponent implements OnInit {

    protected data: any[] = [];

    private _totalCount: number;
    @Input() set totalCount(value: number) {
        if (value == null) { return; }

        this._totalCount = value;
        this.setGaugeData();
    }

    get totalCount(): number {
        return this._totalCount;
    }

    private _offCount: number;
    @Input() set offCount(value: number) {
        if (value == null) { return; }

        this._offCount = value;
        this.setGaugeData();
    }

    get offCount(): number {
        return this._offCount;
    }

    private _waitingCount: number;
    @Input() set waitingCount(value: number) {
        if (value == null) { return; }

        this._waitingCount = value;
        this.setGaugeData();
    }

    get waitingCount(): number {
        return this._waitingCount;
    }

    private _activeCount: number;
    @Input() set activeCount(value: number) {
        if (value == null) { return; }

        this._activeCount = value;
        this.setGaugeData();
    }

    get activeCount(): number {
        return this._activeCount;
    }

    constructor() { }

    ngOnInit(): void {
        console.log('Turf Pro Linear Gauge');
    }

    // =============================================================================================================================================
    // Helper Methods
    // =============================================================================================================================================

    private setGaugeData(): void {
        if (this.activeCount == null || this.waitingCount == null || this.offCount == null || this.totalCount == null) {
            return;
        }

        this.data = [
            { label: 'Off', value: this.offCount, barColor: '#2A2A2A', trackColor: '#EAEAEA' },
            { label: 'Waiting', value: this.waitingCount, barColor: '#9DC1DB', trackColor: '#E9F8FF' },
            { label: 'Active', value: this.activeCount, barColor: '#00A67F', trackColor: '#EAFCEE' },
            { label: 'Total', value: this.totalCount, barColor: '#747474', trackColor: '#3F3F3F1A' },
        ];
    }

}
